import styled from 'styled-components';
import { color } from 'styles/Theme';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Box = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 0.5rem;
	background: ${color.interface.beige3};
`;

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Title = styled.h2`
	margin: 0;
	color: ${color.interface.brown};
	font-size: 1.5rem;
`;

export const Description = styled.p`
	margin: 0;
	color: ${color.interface.gray};
	font-size: 0.875rem;
`;
